import { assertNotEmpty, type Compare, type Optional } from '@festina-life/core'
import { Alert } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'
import { useMemo } from 'react'

import type {
  SubTemplateFieldValue,
  SubTemplateValueSetupField,
} from '../../types/templateModel'
import {
  defaultExcludeKeys,
  stringifyComparableValue,
} from '../diffIndicators/helpers'
import { SubTemplatedFieldValueDiff } from '../diffIndicators/SubTemplatedFieldValueDiff'

export const SpecialCasedNestedSubTemplatedFieldDiff = ({
  current,
  compare,
}: Compare<SubTemplateValueSetupField>) => {
  const translate = useTranslate()
  assertNotEmpty(current)

  const currentVariant = current.value?.variants.at(0)
  const compareVariant = (
    compare as Optional<SubTemplateValueSetupField>
  )?.value?.variants.at(0)

  const comparableProps = useMemo(
    () =>
      ({
        compare: compareVariant,
        current: currentVariant,
      }) as Compare<SubTemplateFieldValue>,
    [compareVariant, currentVariant],
  )

  const areVariantsDifferent = useMemo(() => {
    const excludeKeysWithoutFields = defaultExcludeKeys.filter(
      (key) => key !== 'fields',
    )

    return (
      stringifyComparableValue(currentVariant, excludeKeysWithoutFields) !==
      stringifyComparableValue(compareVariant, excludeKeysWithoutFields)
    )
  }, [compareVariant, currentVariant])

  return (
    <>
      <SubTemplatedFieldValueDiff {...comparableProps} isShowingFieldName />
      {areVariantsDifferent && (
        <Alert severity="warning">
          {translate('diffPopover.field.nativeWarning')}
        </Alert>
      )}
    </>
  )
}
